/** O painel sem conversa: saudação pelo primeiro nome, uma frase do que o
 *  assistente faz e não faz, e as perguntas sugeridas pela tela atual,
 *  clicáveis. Sem ilustração grande: o painel é estreito, e a folha basta. */
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'
import { useAuth } from '@/core/auth/useAuth'
import { useI18n } from '@/core/i18n/useI18n'
import { Leaf } from '@/shared/leaf/LeafDefs'
import { useContextoDaTela, useConversaDoAssistente } from './AssistenteProvider'
import { conjuntoDeSugestoes, sugestoesTraduzidas } from './contexto'

function primeiroNome(nome: string | undefined | null): string {
  return (nome ?? '').trim().split(/\s+/)[0] ?? ''
}

export function EstadoVazio() {
  const { user } = useAuth()
  const { t } = useI18n()
  const contexto = useContextoDaTela()
  const { enviar, limite } = useConversaDoAssistente()
  const nome = primeiroNome(user?.name)
  const sugestoes = sugestoesTraduzidas(t, conjuntoDeSugestoes(contexto?.rota))

  return (
    <Box
      className="anim-fade-up"
      sx={{ flex: 1, minHeight: 0, overflowY: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', px: 2.5, py: 3, gap: 1 }}
    >
      <Box sx={{ color: 'primary.main', display: 'flex', mb: 0.5 }} aria-hidden>
        <Leaf style={{ height: 22, width: 'auto' }} />
      </Box>
      <Typography sx={{ fontFamily: '"Fredoka", sans-serif', fontSize: '1.25rem', fontWeight: 500, lineHeight: 1.25, color: 'text.primary' }}>
        {nome ? t('assistente.vazio.saudacao', { nome }) : t('assistente.vazio.saudacaoSemNome')}
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', lineHeight: 1.5 }}>
        {t('assistente.vazio.frase')}
      </Typography>

      {sugestoes.length > 0 && (
        <>
          <Typography sx={{ mt: 2, fontSize: '0.625rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'text.disabled' }}>
            {t('assistente.vazio.sugestoes')}
          </Typography>
          <Box className="anim-stagger" sx={{ display: 'grid', gap: 0.75 }}>
            {sugestoes.map((pergunta) => (
              <ButtonBase
                key={pergunta}
                onClick={() => enviar(pergunta)}
                // No teto diário a pergunta não sai. O botão não pode continuar
                // com cara de clicável e não fazer nada.
                disabled={Boolean(limite)}
                sx={{
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  px: 1.5,
                  py: 1,
                  borderRadius: '0 12px 0 12px',
                  border: '1px solid',
                  borderColor: 'divider',
                  fontSize: '0.8125rem',
                  lineHeight: 1.4,
                  color: 'text.primary',
                  transition: 'background-color var(--transition-quick), border-color var(--transition-quick)',
                  '&:hover': { bgcolor: 'action.hover', borderColor: 'primary.main' },
                  '&.Mui-focusVisible': { boxShadow: 'var(--focus-ring)' },
                  '&.Mui-disabled': { color: 'text.disabled' },
                }}
              >
                {pergunta}
              </ButtonBase>
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}
